import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Heart, ChevronDown, ChevronUp, Minus, Plus, ShoppingBag, Truck, RotateCcw, Ruler } from 'lucide-react';
import Header from './components/Header21';
import Footer from './components/Footer21';

const ProductDetail21 = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [selectedSize, setSelectedSize] = useState('M');
    const [quantity, setQuantity] = useState(1);
    const [selectedImage, setSelectedImage] = useState(0);
    const [wishlisted, setWishlisted] = useState(false);
    const [openAccordion, setOpenAccordion] = useState(null);
    const [hoveredThumb, setHoveredThumb] = useState(null);
    const [hoveredRelated, setHoveredRelated] = useState(null);
    const [relatedWishlist, setRelatedWishlist] = useState({});

    const allProducts = [
        {
            id: 1,
            name: 'Midnight Silk Lehenga',
            price: 24999,
            originalPrice: 29999,
            category: 'Lehengas',
            description: 'A breathtaking midnight silk lehenga featuring intricate zardozi embroidery and hand-placed Swarovski crystals. This piece is a testament to the artistry of Indian couture, designed for those who command attention at every soiree.',
            images: [
                'https://images.pexels.com/photos/9419032/pexels-photo-9419032.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/11707056/pexels-photo-11707056.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/6687182/pexels-photo-6687182.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/7123307/pexels-photo-7123307.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 2,
            name: 'Noir Banarasi Saree',
            price: 18500,
            category: 'Sarees',
            description: 'Woven by master artisans of Varanasi, this Banarasi saree in deep noir features gold zari work that catches light like liquid gold. A timeless piece for the woman who appreciates heritage craftsmanship.',
            images: [
                'https://images.pexels.com/photos/11707056/pexels-photo-11707056.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/9419032/pexels-photo-9419032.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/5595710/pexels-photo-5595710.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/2723623/pexels-photo-2723623.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 3,
            name: 'Black Zardozi Sherwani',
            price: 32000,
            category: 'Sherwanis',
            description: 'A masterfully tailored sherwani in pure black silk, adorned with dense zardozi embroidery in antique gold. The silhouette is structured yet fluid, embodying the perfect union of tradition and modern sophistication.',
            images: [
                'https://images.pexels.com/photos/6687182/pexels-photo-6687182.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/7123307/pexels-photo-7123307.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/9419032/pexels-photo-9419032.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/9901808/pexels-photo-9901808.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 4,
            name: 'Emerald Velvet Anarkali',
            price: 15999,
            category: 'Anarkalis',
            description: 'Rich emerald velvet cascades into a voluminous floor-length anarkali, accented with delicate gold thread work along the neckline and hemline. A regal piece for festive celebrations.',
            images: [
                'https://images.pexels.com/photos/7123307/pexels-photo-7123307.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/5595710/pexels-photo-5595710.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/11707056/pexels-photo-11707056.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/2723623/pexels-photo-2723623.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 5,
            name: 'Onyx Silk Dupatta Set',
            price: 12499,
            originalPrice: 14999,
            category: 'Indo-Western',
            description: 'An elegant fusion of Indo-Western sensibility, this onyx silk set pairs a structured kurta with a flowing dupatta featuring hand-block printed motifs. Perfect for the modern connoisseur.',
            images: [
                'https://images.pexels.com/photos/5595710/pexels-photo-5595710.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/2723623/pexels-photo-2723623.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/9419032/pexels-photo-9419032.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/17611651/pexels-photo-17611651.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 6,
            name: 'Champagne Gold Saree',
            price: 21000,
            category: 'Sarees',
            description: 'Spun from the finest champagne-gold silk, this saree shimmers with understated luxury. Delicate self-pattern weaving and a rich gold border make it a wardrobe essential for grand occasions.',
            images: [
                'https://images.pexels.com/photos/2723623/pexels-photo-2723623.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/11707056/pexels-photo-11707056.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/9901808/pexels-photo-9901808.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/7123307/pexels-photo-7123307.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 7,
            name: 'Royal Crimson Lehenga',
            price: 28999,
            originalPrice: 34999,
            category: 'Lehengas',
            description: 'A showstopping crimson lehenga featuring layers of tulle and silk, adorned with sequin and resham embroidery. The dramatic flare and deep colour make it the ultimate bridal statement.',
            images: [
                'https://images.pexels.com/photos/9901808/pexels-photo-9901808.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/9419032/pexels-photo-9419032.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/6687182/pexels-photo-6687182.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/5595710/pexels-photo-5595710.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 8,
            name: 'Ivory Chanderi Kurta',
            price: 8999,
            category: 'Indo-Western',
            description: 'Crafted from handwoven Chanderi silk, this ivory kurta features subtle gold butis and a clean contemporary silhouette. Equally refined for a festive gathering or an intimate evening.',
            images: [
                'https://images.pexels.com/photos/17611651/pexels-photo-17611651.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/2723623/pexels-photo-2723623.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/5595710/pexels-photo-5595710.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/11707056/pexels-photo-11707056.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
    ];

    const productId = parseInt(id) || 1;
    const product = allProducts.find(p => p.id === productId) || allProducts[0];
    const relatedProducts = allProducts.filter(p => p.id !== product.id).slice(0, 4);

    const sizes = ['S', 'M', 'L', 'XL', 'XXL'];

    const accordionItems = [
        {
            key: 'material',
            title: 'Material & Care',
            icon: <RotateCcw size={18} style={{ color: '#C9A96E' }} />,
            content: 'Fabric: Pure silk with zardozi embroidery. Lining: Cotton silk blend for comfort. Care: Dry clean only. Store in a muslin cloth bag away from direct sunlight. Avoid contact with perfumes and deodorants. Iron on low heat with a pressing cloth.',
        },
        {
            key: 'shipping',
            title: 'Shipping Info',
            icon: <Truck size={18} style={{ color: '#C9A96E' }} />,
            content: 'Free shipping on orders above \u20B910,000. Standard delivery: 5-7 business days. Express delivery: 2-3 business days (\u20B9500 additional). International shipping available to 30+ countries. All orders are insured and shipped in premium packaging.',
        },
        {
            key: 'size',
            title: 'Size Guide',
            icon: <Ruler size={18} style={{ color: '#C9A96E' }} />,
            content: 'S: Bust 34", Waist 28", Hip 36" | M: Bust 36", Waist 30", Hip 38" | L: Bust 38", Waist 32", Hip 40" | XL: Bust 40", Waist 34", Hip 42" | XXL: Bust 42", Waist 36", Hip 44". For the perfect fit, we recommend booking a virtual consultation with our styling team.',
        },
    ];

    const toggleAccordion = (key) => {
        setOpenAccordion(prev => prev === key ? null : key);
    };

    const toggleRelatedWishlist = (e, productId) => {
        e.stopPropagation();
        setRelatedWishlist(prev => ({ ...prev, [productId]: !prev[productId] }));
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400;1,500&family=DM+Sans:wght@300;400;500;600;700&display=swap');

                .noir-pd-layout {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 32px;
                }
                @media (min-width: 1024px) {
                    .noir-pd-layout {
                        grid-template-columns: 55% 45%;
                        gap: 48px;
                    }
                }
                .noir-thumb-grid {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 12px;
                }
                .noir-related-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 16px;
                }
                @media (min-width: 768px) {
                    .noir-related-grid {
                        grid-template-columns: repeat(4, 1fr);
                        gap: 20px;
                    }
                }
                .noir-sticky-add-bar {
                    display: none;
                }
                .noir-desktop-add-btn {
                    display: block;
                }
                @media (max-width: 1023px) {
                    .noir-sticky-add-bar {
                        display: flex;
                    }
                    .noir-desktop-add-btn {
                        display: none;
                    }
                }
                .noir-breadcrumb-link {
                    color: #C9A96E;
                    cursor: pointer;
                    transition: color 0.3s ease;
                    text-decoration: none;
                    background: none;
                    border: none;
                    padding: 0;
                    font-family: 'DM Sans', -apple-system, sans-serif;
                    font-size: 13px;
                }
                .noir-breadcrumb-link:hover {
                    color: #D4B87A;
                }
            `}</style>

            <div style={{ minHeight: '100vh', backgroundColor: '#0A0A0A' }}>
                <Header cartCount={0} />

                {/* Main Content */}
                <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '100px 24px 80px' }}>

                    {/* Breadcrumb */}
                    <nav
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            marginBottom: '32px',
                            flexWrap: 'wrap',
                        }}
                    >
                        <button className="noir-breadcrumb-link" onClick={() => navigate('/template21')}>
                            Home
                        </button>
                        <span style={{ color: '#8A8A7A', fontFamily: "'DM Sans', -apple-system, sans-serif", fontSize: '13px' }}>/</span>
                        <button className="noir-breadcrumb-link" onClick={() => navigate('/template21/shop')}>
                            Shop
                        </button>
                        <span style={{ color: '#8A8A7A', fontFamily: "'DM Sans', -apple-system, sans-serif", fontSize: '13px' }}>/</span>
                        <span
                            style={{
                                fontFamily: "'DM Sans', -apple-system, sans-serif",
                                fontSize: '13px',
                                color: '#8A8A7A',
                            }}
                        >
                            {product.name}
                        </span>
                    </nav>

                    {/* Product Section */}
                    <div className="noir-pd-layout" style={{ marginBottom: '80px' }}>

                        {/* Left: Image Gallery */}
                        <div>
                            {/* Main Image */}
                            <div
                                style={{
                                    border: '1px solid #2A2A2A',
                                    overflow: 'hidden',
                                    marginBottom: '12px',
                                    backgroundColor: '#141414',
                                }}
                            >
                                <img
                                    src={product.images[selectedImage]}
                                    alt={product.name}
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        display: 'block',
                                        aspectRatio: '3 / 4',
                                        objectFit: 'cover',
                                    }}
                                />
                            </div>

                            {/* Thumbnail Strip */}
                            <div className="noir-thumb-grid">
                                {product.images.map((image, index) => (
                                    <button
                                        key={index}
                                        onClick={() => setSelectedImage(index)}
                                        onMouseEnter={() => setHoveredThumb(index)}
                                        onMouseLeave={() => setHoveredThumb(null)}
                                        style={{
                                            border: selectedImage === index
                                                ? '2px solid #C9A96E'
                                                : hoveredThumb === index
                                                    ? '2px solid #8A8A7A'
                                                    : '2px solid #2A2A2A',
                                            overflow: 'hidden',
                                            cursor: 'pointer',
                                            padding: 0,
                                            backgroundColor: '#141414',
                                            transition: 'border-color 0.3s ease',
                                        }}
                                    >
                                        <img
                                            src={image}
                                            alt={`${product.name} view ${index + 1}`}
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                aspectRatio: '1 / 1',
                                                objectFit: 'cover',
                                                display: 'block',
                                                opacity: selectedImage === index ? 1 : 0.7,
                                                transition: 'opacity 0.3s ease',
                                            }}
                                        />
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Right: Product Details */}
                        <div>
                            {/* Category */}
                            <p
                                style={{
                                    fontFamily: "'DM Sans', -apple-system, sans-serif",
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    color: '#C9A96E',
                                    letterSpacing: '3px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 12px 0',
                                }}
                            >
                                {product.category}
                            </p>

                            {/* Product Name */}
                            <h1
                                style={{
                                    fontFamily: "'Cormorant Garamond', Georgia, serif",
                                    fontSize: 'clamp(28px, 4vw, 40px)',
                                    fontWeight: 500,
                                    color: '#F5F0EB',
                                    margin: '0 0 20px 0',
                                    lineHeight: 1.2,
                                    letterSpacing: '1px',
                                }}
                            >
                                {product.name}
                            </h1>

                            {/* Price */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
                                <span
                                    style={{
                                        fontFamily: "'DM Sans', -apple-system, sans-serif",
                                        fontSize: '28px',
                                        fontWeight: 600,
                                        color: '#C9A96E',
                                    }}
                                >
                                    {'\u20B9'}{product.price.toLocaleString('en-IN')}
                                </span>
                                {product.originalPrice && (
                                    <>
                                        <span
                                            style={{
                                                fontFamily: "'DM Sans', -apple-system, sans-serif",
                                                fontSize: '18px',
                                                color: '#8A8A7A',
                                                textDecoration: 'line-through',
                                            }}
                                        >
                                            {'\u20B9'}{product.originalPrice.toLocaleString('en-IN')}
                                        </span>
                                        <span
                                            style={{
                                                fontFamily: "'DM Sans', -apple-system, sans-serif",
                                                fontSize: '12px',
                                                fontWeight: 600,
                                                color: '#0A0A0A',
                                                backgroundColor: '#C9A96E',
                                                padding: '4px 10px',
                                                borderRadius: '20px',
                                                letterSpacing: '0.5px',
                                            }}
                                        >
                                            {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}% OFF
                                        </span>
                                    </>
                                )}
                            </div>

                            {/* Description */}
                            <p
                                style={{
                                    fontFamily: "'DM Sans', -apple-system, sans-serif",
                                    fontSize: '14px',
                                    fontWeight: 300,
                                    color: '#8A8A7A',
                                    lineHeight: 1.8,
                                    margin: '0 0 32px 0',
                                }}
                            >
                                {product.description}
                            </p>

                            {/* Divider */}
                            <div style={{ borderTop: '1px solid #2A2A2A', margin: '0 0 28px 0' }} />

                            {/* Size Selector */}
                            <div style={{ marginBottom: '28px' }}>
                                <label
                                    style={{
                                        fontFamily: "'DM Sans', -apple-system, sans-serif",
                                        fontSize: '12px',
                                        fontWeight: 500,
                                        color: '#F5F0EB',
                                        letterSpacing: '2px',
                                        textTransform: 'uppercase',
                                        display: 'block',
                                        marginBottom: '14px',
                                    }}
                                >
                                    Select Size
                                </label>
                                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                    {sizes.map(size => (
                                        <button
                                            key={size}
                                            onClick={() => setSelectedSize(size)}
                                            style={{
                                                width: '52px',
                                                height: '52px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontFamily: "'DM Sans', -apple-system, sans-serif",
                                                fontSize: '13px',
                                                fontWeight: 500,
                                                backgroundColor: selectedSize === size ? '#C9A96E' : '#141414',
                                                color: selectedSize === size ? '#0A0A0A' : '#F5F0EB',
                                                border: selectedSize === size ? '1px solid #C9A96E' : '1px solid #2A2A2A',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s ease',
                                            }}
                                            onMouseEnter={(e) => {
                                                if (selectedSize !== size) {
                                                    e.currentTarget.style.borderColor = '#C9A96E';
                                                    e.currentTarget.style.color = '#C9A96E';
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                if (selectedSize !== size) {
                                                    e.currentTarget.style.borderColor = '#2A2A2A';
                                                    e.currentTarget.style.color = '#F5F0EB';
                                                }
                                            }}
                                        >
                                            {size}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {/* Quantity */}
                            <div style={{ marginBottom: '32px' }}>
                                <label
                                    style={{
                                        fontFamily: "'DM Sans', -apple-system, sans-serif",
                                        fontSize: '12px',
                                        fontWeight: 500,
                                        color: '#F5F0EB',
                                        letterSpacing: '2px',
                                        textTransform: 'uppercase',
                                        display: 'block',
                                        marginBottom: '14px',
                                    }}
                                >
                                    Quantity
                                </label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0' }}>
                                    <button
                                        onClick={() => setQuantity(prev => Math.max(1, prev - 1))}
                                        style={{
                                            width: '48px',
                                            height: '48px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: '#1A1A1A',
                                            border: '1px solid #2A2A2A',
                                            color: '#C9A96E',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s ease',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#C9A96E';
                                            e.currentTarget.style.color = '#0A0A0A';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = '#1A1A1A';
                                            e.currentTarget.style.color = '#C9A96E';
                                        }}
                                    >
                                        <Minus size={16} />
                                    </button>
                                    <div
                                        style={{
                                            width: '64px',
                                            height: '48px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: '#1A1A1A',
                                            borderTop: '1px solid #2A2A2A',
                                            borderBottom: '1px solid #2A2A2A',
                                            fontFamily: "'DM Sans', -apple-system, sans-serif",
                                            fontSize: '16px',
                                            fontWeight: 500,
                                            color: '#F5F0EB',
                                        }}
                                    >
                                        {quantity}
                                    </div>
                                    <button
                                        onClick={() => setQuantity(prev => prev + 1)}
                                        style={{
                                            width: '48px',
                                            height: '48px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: '#1A1A1A',
                                            border: '1px solid #2A2A2A',
                                            color: '#C9A96E',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s ease',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#C9A96E';
                                            e.currentTarget.style.color = '#0A0A0A';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = '#1A1A1A';
                                            e.currentTarget.style.color = '#C9A96E';
                                        }}
                                    >
                                        <Plus size={16} />
                                    </button>
                                </div>
                            </div>

                            {/* Add to Bag + Wishlist (Desktop) */}
                            <div className="noir-desktop-add-btn" style={{ display: 'flex', gap: '12px', marginBottom: '32px' }}>
                                <button
                                    onClick={() => navigate('/template21/cart')}
                                    style={{
                                        flex: 1,
                                        height: '56px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '10px',
                                        backgroundColor: '#C9A96E',
                                        color: '#0A0A0A',
                                        border: 'none',
                                        fontFamily: "'DM Sans', -apple-system, sans-serif",
                                        fontSize: '14px',
                                        fontWeight: 600,
                                        letterSpacing: '2px',
                                        textTransform: 'uppercase',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s ease',
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#D4B87A')}
                                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#C9A96E')}
                                >
                                    <ShoppingBag size={18} />
                                    Add to Bag
                                </button>
                                <button
                                    onClick={() => setWishlisted(prev => !prev)}
                                    style={{
                                        width: '56px',
                                        height: '56px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: 'transparent',
                                        border: '1px solid #2A2A2A',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.borderColor = '#C9A96E')}
                                    onMouseLeave={(e) => (e.currentTarget.style.borderColor = '#2A2A2A')}
                                >
                                    <Heart
                                        size={20}
                                        style={{
                                            color: wishlisted ? '#C9A96E' : '#F5F0EB',
                                            fill: wishlisted ? '#C9A96E' : 'none',
                                            transition: 'color 0.3s ease, fill 0.3s ease',
                                        }}
                                    />
                                </button>
                            </div>

                            {/* Divider */}
                            <div style={{ borderTop: '1px solid #2A2A2A', margin: '0 0 24px 0' }} />

                            {/* Accordion Sections */}
                            <div>
                                {accordionItems.map((item, index) => (
                                    <div
                                        key={item.key}
                                        style={{
                                            borderBottom: index < accordionItems.length - 1 ? '1px solid #2A2A2A' : 'none',
                                        }}
                                    >
                                        <button
                                            onClick={() => toggleAccordion(item.key)}
                                            style={{
                                                width: '100%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                padding: '18px 0',
                                                backgroundColor: 'transparent',
                                                border: 'none',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                {item.icon}
                                                <span
                                                    style={{
                                                        fontFamily: "'DM Sans', -apple-system, sans-serif",
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        color: '#F5F0EB',
                                                        letterSpacing: '1px',
                                                    }}
                                                >
                                                    {item.title}
                                                </span>
                                            </div>
                                            {openAccordion === item.key ? (
                                                <ChevronUp size={18} style={{ color: '#C9A96E' }} />
                                            ) : (
                                                <ChevronDown size={18} style={{ color: '#C9A96E' }} />
                                            )}
                                        </button>
                                        {openAccordion === item.key && (
                                            <div
                                                style={{
                                                    padding: '0 0 18px 30px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        fontFamily: "'DM Sans', -apple-system, sans-serif",
                                                        fontSize: '13px',
                                                        fontWeight: 300,
                                                        color: '#8A8A7A',
                                                        lineHeight: 1.8,
                                                        margin: 0,
                                                    }}
                                                >
                                                    {item.content}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* You May Also Like */}
                    <div style={{ marginBottom: '40px' }}>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                marginBottom: '32px',
                            }}
                        >
                            <h2
                                style={{
                                    fontFamily: "'Cormorant Garamond', Georgia, serif",
                                    fontSize: 'clamp(24px, 3vw, 32px)',
                                    fontWeight: 500,
                                    color: '#F5F0EB',
                                    margin: 0,
                                    letterSpacing: '1px',
                                }}
                            >
                                You May Also Like
                            </h2>
                            <button
                                onClick={() => navigate('/template21/shop')}
                                style={{
                                    fontFamily: "'DM Sans', -apple-system, sans-serif",
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    color: '#C9A96E',
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    cursor: 'pointer',
                                    letterSpacing: '1px',
                                    textTransform: 'uppercase',
                                    transition: 'color 0.3s ease',
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.color = '#D4B87A')}
                                onMouseLeave={(e) => (e.currentTarget.style.color = '#C9A96E')}
                            >
                                View All
                            </button>
                        </div>

                        <div className="noir-related-grid">
                            {relatedProducts.map(rp => (
                                <div
                                    key={rp.id}
                                    onClick={() => {
                                        navigate(`/template21/product/${rp.id}`);
                                        setSelectedImage(0);
                                        setSelectedSize('M');
                                        setQuantity(1);
                                        setOpenAccordion(null);
                                        window.scrollTo(0, 0);
                                    }}
                                    onMouseEnter={() => setHoveredRelated(rp.id)}
                                    onMouseLeave={() => setHoveredRelated(null)}
                                    style={{
                                        backgroundColor: '#141414',
                                        border: `1px solid ${hoveredRelated === rp.id ? '#C9A96E' : '#2A2A2A'}`,
                                        cursor: 'pointer',
                                        transition: 'border-color 0.3s ease',
                                        overflow: 'hidden',
                                    }}
                                >
                                    {/* Image */}
                                    <div
                                        style={{
                                            position: 'relative',
                                            aspectRatio: '3 / 4',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <img
                                            src={rp.images[0]}
                                            alt={rp.name}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                transform: hoveredRelated === rp.id ? 'scale(1.05)' : 'scale(1)',
                                                transition: 'transform 0.5s ease',
                                            }}
                                        />

                                        {/* Wishlist */}
                                        <button
                                            onClick={(e) => toggleRelatedWishlist(e, rp.id)}
                                            style={{
                                                position: 'absolute',
                                                top: '10px',
                                                right: '10px',
                                                width: '32px',
                                                height: '32px',
                                                backgroundColor: 'rgba(10, 10, 10, 0.6)',
                                                border: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer',
                                                backdropFilter: 'blur(4px)',
                                                transition: 'background-color 0.3s ease',
                                            }}
                                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgba(10, 10, 10, 0.8)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'rgba(10, 10, 10, 0.6)')}
                                        >
                                            <Heart
                                                size={15}
                                                style={{
                                                    color: relatedWishlist[rp.id] ? '#C9A96E' : '#F5F0EB',
                                                    fill: relatedWishlist[rp.id] ? '#C9A96E' : 'none',
                                                    transition: 'color 0.3s ease, fill 0.3s ease',
                                                }}
                                            />
                                        </button>
                                    </div>

                                    {/* Info */}
                                    <div style={{ padding: '14px' }}>
                                        <h3
                                            style={{
                                                fontFamily: "'DM Sans', -apple-system, sans-serif",
                                                fontSize: '13px',
                                                fontWeight: 500,
                                                color: '#F5F0EB',
                                                margin: '0 0 6px 0',
                                                lineHeight: 1.4,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            {rp.name}
                                        </h3>
                                        <span
                                            style={{
                                                fontFamily: "'DM Sans', -apple-system, sans-serif",
                                                fontSize: '15px',
                                                fontWeight: 600,
                                                color: '#C9A96E',
                                            }}
                                        >
                                            {'\u20B9'}{rp.price.toLocaleString('en-IN')}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <Footer />

                {/* Mobile Sticky Add to Bag Bar */}
                <div
                    className="noir-sticky-add-bar"
                    style={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        zIndex: 40,
                        backgroundColor: '#C9A96E',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        padding: '16px 24px',
                        boxShadow: '0 -4px 20px rgba(0,0,0,0.5)',
                    }}
                    onClick={() => navigate('/template21/cart')}
                >
                    <ShoppingBag size={18} style={{ color: '#0A0A0A' }} />
                    <span
                        style={{
                            fontFamily: "'DM Sans', -apple-system, sans-serif",
                            fontSize: '14px',
                            fontWeight: 600,
                            color: '#0A0A0A',
                            letterSpacing: '2px',
                            textTransform: 'uppercase',
                        }}
                    >
                        Add to Bag &mdash; {'\u20B9'}{(product.price * quantity).toLocaleString('en-IN')}
                    </span>
                </div>
            </div>
        </>
    );
};

export default ProductDetail21;
